/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { object } from 'prop-types';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
// import HowToVideos from './Partials/HowToVideos';
import { queryVariables } from '../../../../utils/queryURL';
import { useAuth } from '../../../../../../../state/ducks/Member/ducks/Auth/Plugin/auth';
import GiftListRecommendationsSFContainer from '../../GiftListRecommendationsSFContainer';

const styles = (theme) => ({
    contentWrapper: {
        width: '100%',
        maxWidth: '1170px',
        margin: '0 auto',
    },
    giftlistTopBanner: {
        background: 'url(https://cdn1.harryanddavid.com/wcsstore/HarryAndDavid/images/giftListLander/gift-list-banner.jpg)',
        backgroundColor: '#FDFBFA', // extended background color after image
        backgroundRepeat: 'no-repeat',
        width: '100%',
        maxWidth: '1170px',
        height: '95px',
        display: 'flex',
        justifyContent: 'center',
        border: '1px solid #CCC', // TODO
        marginBottom: 24,
        '& h1': {
            width: '400px',
            alignSelf: 'center',
            textAlign: 'right',
            marginRight: '48px',
            fontSize: '30px !important',
            fontWeight: 'normal !important',
            marginTop: '0',
            marginBottom: '0 !important',
        },
        '& p': {
            flex: 1,
            alignSelf: 'center',
            margin: '0 !important',
        },
    },
    contentGrid: {
        marginBottom: 24,
        display: 'flex',
    },
    block: {
        flex: 1,
        border: `${'1px solid'} ${theme.palette.myAccount.contentGridBorder}`,
        marginRight: 12,
        '&:last-child': {
            marginRight: 0,
            marginLeft: 12,
        },
    },
    blockHeader: {
        backgroundColor: theme.palette.grey7,
        color: theme.palette.myAccount.blockMessageFadedInside,
        textTransform: 'uppercase',
        padding: '10px 10px',
        fontWeight: 600,
        borderRadius: 2,
    },
    blockContent: {
        padding: '12px 48px',
        minHeight: 150,
        lineHeight: 1.5,
        '&.guest': {
            marginTop: 24,
            textAlign: 'center',
        },
        '& .giftListButton': {
            float: 'none !important',
            margin: 0,
        },
    },
});

const DesktopGiftListLogin = ({ classes }) => {
    const params = queryVariables();
    const { loginByRedirect } = useAuth();

    return (
        <div className={classes.contentWrapper}>
            <div className={classes.giftlistTopBanner}>
                <h1>GIFT LIST</h1>
                <p>
                    Gift List makes it easy to remember what you gave in the
                    <br />
                    past so you can plan and complete this year&apos;s gift giving.
                </p>
            </div>

            <div className={classes.contentGrid}>
                <div className={classes.block}>
                    <div className={classes.blockHeader}>Returning Customers</div>
                    <div className={classes.blockContent}>
                        <h3>Welcome Gift List Customer</h3>
                        <p>
                            Please sign in to securely access your personal gifting
                            information.
                        </p>
                        <div className="row align-center margin-bottom-2x margin-top-2x">
                            <Button
                                variant="contained"
                                className="giftListButton"
                                onClick={async () => {
                                    if (params.custNbr) {
                                        await loginByRedirect({}, { custNbr: params.custNbr });
                                    } else {
                                        await loginByRedirect();
                                    }
                                }}
                            >
                                Sign In
                            </Button>
                        </div>
                    </div>
                </div>
                <div className={classes.block}>
                    <div className={classes.blockHeader}>Guests</div>
                    <div className={`${classes.blockContent} guest`}>
                        <p>
                            Start shopping with your Gift List now by creating an
                            account.
                        </p>
                        <div className="row align-center margin-bottom-2x margin-top-2x">
                            <Button
                                variant="contained"
                                className="secondary giftListButton"
                                onClick={async () => {
                                    if (params.custNbr) {
                                        await loginByRedirect({}, { register: 'Y', custNbr: params.custNbr });
                                    } else {
                                        await loginByRedirect({}, { register: 'Y' });
                                    }
                                }}
                            >
                                Create Account
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
            {/* <HowToVideos /> */}
            <GiftListRecommendationsSFContainer title_font_size="26px" title_font_style="normal" title_font_family="'LatoRegular', 'Arial', 'Verdana', sans-serif" />
        </div>
    );
};

DesktopGiftListLogin.propTypes = {
    classes: object.isRequired,
};

export default withRouter(withStyles(styles)(DesktopGiftListLogin));
